import axios from 'axios';
import Vue from 'vue';
import JWTService from './JWTService';
import { RESPONSE_CODES } from '@/helpers/getApiErrorMessage';

const commonHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json;charset=UTF-8',
};

class ApiService {
  constructor(baseURL) {
    this.cacheStorage = {};
    this.tokenInterceptor = null;
    this.refreshTokenInterceptor = null;
    this.axios = axios.create({
      baseURL,
      headers: {
        ...commonHeaders,
      },
    });

    this.axios.interceptors.response.use(
      (response) => {
        const { result_code, data, result_message } = response?.data || {};

        if (!response || result_code !== 'FLSCS') {
          const message = data?.message || RESPONSE_CODES[result_code] || result_message;
          if (message) {
            Vue.$toast.error(data?.message || RESPONSE_CODES[result_code] || result_message, { icon: 'error' });
          }
        }
        return response;
      },

      (error) => {
        // @redirect error
        const status = error?.response?.status;

        switch (status) {
          case 500: {
            Vue.$router?.push('/500');
            break;
          }
          case 404: {
            Vue.$router?.push('/404');
            break;
          }
          case 403: {
            Vue.$router?.push('/403');
            break;
          }
          case 401: {
            // const path = window.location.pathname;
            // window.location.href = `/login?redirect=${path}`;
            break;
          }
          default:
            break;
        }

        return Promise.reject(error);
      },
    );
  }

  changeApiUrl(url) {
    if (!url) {
      return;
    }

    this.axios.defaults.baseURL = url;
  }

  getCached(resource, params) {
    const key = params ? `${resource}_${JSON.stringify(params)}` : resource;
    const value = this.cacheStorage[key];
    if (value) return value;

    this.cacheStorage[key] = this.get(resource, params);
    return this.cacheStorage[key];
  }

  get(resource, params) {
    if (!params && this.cacheStorage[resource]) {
      this.getCached(resource);
    }

    return this.axios.get(`${resource}`, { params });
  }

  headers(resource, params) {
    return this.axios.headers(`${resource}`, { params });
  }

  post(resource, params, headers) {
    return this.axios.post(`${resource}`, params, headers);
  }

  put(resource, params) {
    return this.axios.put(`${resource}`, params);
  }

  patch(resource, params) {
    return this.axios.patch(`${resource}`, params);
  }

  delete(resource, params) {
    return this.axios.delete(resource, params);
  }

  customRequest(data) {
    return this.axios(data);
  }

  mountAuthInterceptors() {
    this.tokenInterceptor = this.axios.interceptors.request.use((config) => {
      const token = JWTService.getToken();
      config.headers.Authorization = token ? `Bearer ${token}` : 'sdfsaf';
      return config;
    });
  }

  unmountAuthInterceptors() {
    // Eject the interceptors
    this.axios.interceptors.request.eject(this.tokenInterceptor);
    this.axios.interceptors.response.eject(this.refreshTokenInterceptor);
  }
}

export const apiService = new ApiService(process.env.VUE_APP_API_URL);
export const apiReestr = new ApiService(process.env.VUE_APP_API_REESTR_URL);
export const apiDirectoryService = new ApiService(process.env.VUE_APP_DIRECTORY_URL);
export const apiDadataService = axios.create({
  baseURL: process.env.VUE_APP_DADATA_URL,
  headers: {
    ...commonHeaders,
    Authorization: `Token ${process.env.VUE_APP_DADATA_TOKEN}`,
  },
});
export const customApiService = (path) => new ApiService(path);
